/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type InvitePolicyEnum = "AdminOnly" | "AnyMember" | "%future added value";
export type SearchPersonStatusResponse = "Deactivated" | "Invited" | "NonUser" | "User" | "%future added value";
export type AdminSelect_org = {
    readonly id: string;
    readonly orgPersonListPaginatedErrorable: {
        readonly __typename: "GraphEntityError";
        readonly message: string | null;
    } | {
        readonly __typename: "OrgPersonListPaginated";
        readonly inputQuery: string | null;
        readonly nextPersonId: string | null;
        readonly previousPersonId: string | null;
        readonly searchPersons: ReadonlyArray<{
            readonly person: {
                readonly primaryCalendarId: string;
                readonly userId: string | null;
                readonly personId: string;
                readonly signUpMillis: unknown | null;
                readonly isYou: boolean;
                readonly primaryBillingGroupIdErrorable: ({
                    readonly __typename: "PrimaryBillingGroupId";
                    readonly primaryBillingGroupId: string | null;
                } | {
                    readonly __typename: "GraphEntityError";
                    readonly message: string | null;
                    readonly statusCode: number | null;
                } | {
                    /*This will never be '%other', but we need some
                    value in case none of the concrete values match.*/
                    readonly __typename: "%other";
                }) | null;
                readonly profile: {
                    readonly givenName: string | null;
                    readonly familyName: string | null;
                    readonly externalImageUrl: string | null;
                } | null;
            };
            readonly status: SearchPersonStatusResponse;
        }> | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly billingGroups: {
        readonly list?: ReadonlyArray<{
            readonly id: string;
            readonly name: string;
            readonly createdAtMillis: unknown;
            readonly invitePolicy: InvitePolicyEnum;
            readonly manualMembers: {
                readonly __typename: "BillingGroupManualMemberList";
                readonly list: ReadonlyArray<{
                    readonly externalUserId: string;
                    readonly calendarId: string;
                    readonly userId: string | null;
                    readonly personId: string | null;
                    readonly orgPerson: ({
                        readonly __typename: "OrgPerson";
                        readonly userId: string | null;
                        readonly personId: string;
                        readonly primaryCalendarId: string;
                        readonly isYou: boolean;
                        readonly signUpMillis: unknown | null;
                        readonly profile: {
                            readonly givenName: string | null;
                            readonly familyName: string | null;
                        } | null;
                    } | {
                        readonly __typename: "GraphEntityError";
                        readonly message: string | null;
                        readonly statusCode: number | null;
                    } | {
                        /*This will never be '%other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    }) | null;
                }>;
            } | {
                readonly __typename: "GraphEntityError";
                readonly message: string | null;
                readonly statusCode: number | null;
            } | {
                /*This will never be '%other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            };
            readonly adminOrgPersons: {
                readonly __typename: "OrgPersonList";
                readonly list: ReadonlyArray<{
                    readonly userId: string | null;
                    readonly personId: string;
                    readonly primaryCalendarId: string;
                    readonly isYou: boolean;
                    readonly signUpMillis: unknown | null;
                    readonly profile: {
                        readonly givenName: string | null;
                        readonly familyName: string | null;
                    } | null;
                }>;
            } | {
                readonly __typename: "GraphEntityError";
                readonly message: string | null;
                readonly statusCode: number | null;
            } | {
                /*This will never be '%other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            };
        }> | undefined;
        readonly message?: string | null | undefined;
        readonly statusCode?: number | null | undefined;
    };
    readonly " $refType": "AdminSelect_org";
};
export type AdminSelect_org$data = AdminSelect_org;
export type AdminSelect_org$key = {
    readonly " $data"?: AdminSelect_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AdminSelect_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryCalendarId",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "personId",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "signUpMillis",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v8 = {
        "kind": "InlineFragment",
        "selections": [
            (v2 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statusCode",
                "storageKey": null
            }
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "givenName",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "familyName",
        "storageKey": null
    } as any, v11 = [
        (v4 /*: any*/),
        (v5 /*: any*/),
        (v3 /*: any*/),
        (v7 /*: any*/),
        (v6 /*: any*/),
        {
            "alias": null,
            "args": null,
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
                (v9 /*: any*/),
                (v10 /*: any*/)
            ],
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "activityFilter"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "billingGroupId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "fetchNext"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "limit"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "pageToken"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "searchQuery"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "sortDirection"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "sortType"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "teamId"
            }
        ],
        "kind": "Fragment",
        "metadata": null,
        "name": "AdminSelect_org",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "activityFilter",
                        "variableName": "activityFilter"
                    },
                    {
                        "kind": "Variable",
                        "name": "billingGroupId",
                        "variableName": "billingGroupId"
                    },
                    {
                        "kind": "Variable",
                        "name": "fetchNext",
                        "variableName": "fetchNext"
                    },
                    {
                        "kind": "Variable",
                        "name": "limit",
                        "variableName": "limit"
                    },
                    {
                        "kind": "Variable",
                        "name": "pageToken",
                        "variableName": "pageToken"
                    },
                    {
                        "kind": "Variable",
                        "name": "searchQuery",
                        "variableName": "searchQuery"
                    },
                    {
                        "kind": "Variable",
                        "name": "sortDirection",
                        "variableName": "sortDirection"
                    },
                    {
                        "kind": "Variable",
                        "name": "sortType",
                        "variableName": "sortType"
                    },
                    {
                        "kind": "Variable",
                        "name": "teamId",
                        "variableName": "teamId"
                    }
                ],
                "concreteType": null,
                "kind": "LinkedField",
                "name": "orgPersonListPaginatedErrorable",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v2 /*: any*/)
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "inputQuery",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "nextPersonId",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "previousPersonId",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "SearchPerson",
                                "kind": "LinkedField",
                                "name": "searchPersons",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "OrgPerson",
                                        "kind": "LinkedField",
                                        "name": "person",
                                        "plural": false,
                                        "selections": [
                                            (v3 /*: any*/),
                                            (v4 /*: any*/),
                                            (v5 /*: any*/),
                                            (v6 /*: any*/),
                                            (v7 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "primaryBillingGroupIdErrorable",
                                                "plural": false,
                                                "selections": [
                                                    (v1 /*: any*/),
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "primaryBillingGroupId",
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "PrimaryBillingGroupId",
                                                        "abstractKey": null
                                                    },
                                                    (v8 /*: any*/)
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "UserProfile",
                                                "kind": "LinkedField",
                                                "name": "profile",
                                                "plural": false,
                                                "selections": [
                                                    (v9 /*: any*/),
                                                    (v10 /*: any*/),
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "externalImageUrl",
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "status",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "OrgPersonListPaginated",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "billingGroups",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "BillingGroup",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "name",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "createdAtMillis",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "invitePolicy",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "manualMembers",
                                        "plural": false,
                                        "selections": [
                                            (v1 /*: any*/),
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "BillingGroupManualMember",
                                                        "kind": "LinkedField",
                                                        "name": "list",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "externalUserId",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "calendarId",
                                                                "storageKey": null
                                                            },
                                                            (v4 /*: any*/),
                                                            (v5 /*: any*/),
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": null,
                                                                "kind": "LinkedField",
                                                                "name": "orgPerson",
                                                                "plural": false,
                                                                "selections": [
                                                                    (v1 /*: any*/),
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": (v11 /*: any*/),
                                                                        "type": "OrgPerson",
                                                                        "abstractKey": null
                                                                    },
                                                                    (v8 /*: any*/)
                                                                ],
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "type": "BillingGroupManualMemberList",
                                                "abstractKey": null
                                            },
                                            (v8 /*: any*/)
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "adminOrgPersons",
                                        "plural": false,
                                        "selections": [
                                            (v1 /*: any*/),
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "OrgPerson",
                                                        "kind": "LinkedField",
                                                        "name": "list",
                                                        "plural": true,
                                                        "selections": (v11 /*: any*/),
                                                        "storageKey": null
                                                    }
                                                ],
                                                "type": "OrgPersonList",
                                                "abstractKey": null
                                            },
                                            (v8 /*: any*/)
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "BillingGroupList",
                        "abstractKey": null
                    },
                    (v8 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '98cd44ed7c5e018f9432300cf17f993a';
export default node;
